import getTranslationFunction from "../../../lib/i18n";
import { translationLocale } from "../../../i18n/locale";
import en from "./en";
import fr from "./fr";

export const locales = ["fr", "en"] as const;

const translations = translationLocale === "fr" ? fr : en;

const t = getTranslationFunction(translations);

export default t;
